import Form from "./form";
import { action, observable } from "mobx";
import { lengthAtLeast, notEmpty, validEmail } from "core/validation";

export default class RegistrationForm extends Form {
  @observable firstName: string;
  @observable lastName: string;
  @observable email: string;
  @observable password: string;
  @observable passwordRepeat: string;
  @observable token: string;
  @observable promoCode?: String;

  validators = {
    firstName: notEmpty,
    lastName: notEmpty,
    email: validEmail,
    password: { validator: lengthAtLeast(8), message: "Password must be at least 8 characters" },
    passwordRepeat: {
      validator: (value: string) => {
        return this.password == value;
      },
      message: "Passwords must match",
    }
  };

  ignoreOnPostFields = ["passwordRepeat"];

  @action.bound
  setDefaults() {
    this.firstName = "";
    this.lastName = "";
    this.email = "";
    this.password = "";
    this.passwordRepeat = "";
    this.token = null;
  }
}
